import { KeyFacet, stringPart } from '@ms/items-view/lib/private/models/KeyFacet';

export const driveItemKeyFacet: KeyFacet<{
  endpoint: string;
  driveId?: string;
  itemId?: string;
}> = new KeyFacet('driveItem', {
  endpoint: stringPart(),
  driveId: stringPart({ shouldNormalizeToEmpty: true }),
  itemId: stringPart()
});
